import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import React from 'react';
import { Helmet } from 'react-helmet';
import { appendHtmlClass, getPortalTarget, isServer } from '../../js/util';
import { BreakpointContextProvider, I18nContextProvider } from '../';
import getConfig from '../../js/settings';
import initIcons from './helper';
import './_index.scss';
var THEME = getConfig('THEME');
var THEME_DEFAULT = getConfig('THEME_DEFAULT');
var THEME_PREFIX = getConfig('THEME_PREFIX');
var ENVIRONMENT = getConfig('ENVIRONMENT');
var DEV_SHOW_GRID_DEFAULT = getConfig('DEV_SHOW_GRID_DEFAULT');
var DEV_SHOW_GRID_KEY_CODE = getConfig('DEV_SHOW_GRID_KEY_CODE');
var PORTAL_CONTAINER_ID = getConfig('PORTAL_CONTAINER_ID');
var Root = /*#__PURE__*/function (_React$PureComponent) {
  _inheritsLoose(Root, _React$PureComponent);
  function Root(props) {
    var _this;
    _this = _React$PureComponent.call(this, props) || this;
    initIcons();
    _this.state = {
      gridShow: ENVIRONMENT === 'dev' && DEV_SHOW_GRID_DEFAULT
    };
    if (!isServer()) _this.createPortalContainer();
    return _this;
  }
  var _proto = Root.prototype;
  _proto.componentDidMount = function componentDidMount() {
    this.createPortalContainer();
    window.addEventListener('keyup', this.onKeyUp.bind(this));
  };
  _proto.componentWillUnmount = function componentWillUnmount() {
    window.removeEventListener('keyup', this.onKeyUp.bind(this));
    this.removePortalContainer();
  };
  _proto.createPortalContainer = function createPortalContainer() {
    var container = getPortalTarget();
    if (!container) {
      var body = document.getElementsByTagName('body')[0];
      container = document.createElement('div');
      container.setAttribute('id', PORTAL_CONTAINER_ID);
      body.appendChild(container);
    }
  };
  _proto.removePortalContainer = function removePortalContainer() {
    var container = getPortalTarget();
    if (container) container.parentNode.removeChild(container);
  };
  _proto.onKeyUp = function onKeyUp(e) {
    // See https://developer.mozilla.org/en-US/docs/Web/API/Document/keyup_event
    if (e.isComposing || e.keyCode === 229) return;
    if (ENVIRONMENT === 'dev' && e.keyCode === DEV_SHOW_GRID_KEY_CODE) {
      this.setState(function (state, props) {
        return {
          gridShow: !state.gridShow
        };
      });
      e.preventDefault();
      return false;
    }
  };
  _proto.render = function render() {
    var theme = "" + THEME_PREFIX + THEME[this.props.theme];
    var grid = this.state.gridShow ? 'grid-show' : null;
    var className = appendHtmlClass(theme, grid);
    var id = getConfig('BODY_ID');
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Helmet, null, /*#__PURE__*/React.createElement("body", {
      id: id,
      className: className
    }), this.props.head), /*#__PURE__*/React.createElement(I18nContextProvider, {
      translations: this.props.translations
    }, /*#__PURE__*/React.createElement(BreakpointContextProvider, {
      isServerSide: this.props.isServerSide
    }, this.props.children)));
  };
  return Root;
}(React.PureComponent);
Root.defaultProps = {
  theme: THEME_DEFAULT,
  isServerSide: false
};
export default Root;